import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import noticeAPI from "api/noticeAPI";

// NOTICES
const getNotices = createAsyncThunk(
  "GET_NOTICES",
  async (_arg, { rejectWithValue }) => {
    try {
      const res = await noticeAPI.getNotices(_arg);
      if( res.sorrypage == '0') {
        return { 
          notice: {},
          isInLine: true 
        };
      }
      return {
        notice: res.data.notice,
        isInLine: res.data.isInLine
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getInitNotice = createAsyncThunk(
  "GET_INIT_NOTICES",
  async (_arg, { rejectWithValue }) => {
    try {
      const res = await noticeAPI.getInitNotice(_arg);
      return res.message.notice;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const getNotice = createAsyncThunk(
  "GET_NOTICE",
  async (_arg, { rejectWithValue }) => {
    try {
      const res = await noticeAPI.getNotice(_arg);
      if( res.sorrypage == '0') {
        return { 
          notice: {},
          isInLine: true 
        };
      }
      return {
        notice: res.data.notice,
        isInLine: res.data.isInLine
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const clearGetNoticeError = createAction("CLEAR_GET_NOTICE_ERROR");

const initialState = {
  notices: null,
  notice: null,
  noticesInit: null,
  isInLine: false
};

const newSlice = createSlice({
  name: "new",
  initialState,
  extraReducers: {
    // NOTICES
    [getNotices.fulfilled]: (state, action) => {
      state.notices = action.payload.notice;
      state.isInLine = action.payload.isInLine;
    },
    [getInitNotice.fulfilled]: (state, action) => {
      state.noticesInit = action.payload;
    },
    [getNotice.fulfilled]: (state, action) => {
      state.notice = action.payload.notice;
      state.isInLine = action.payload.isInLine;
    },
  },
});

const { reducer } = newSlice;
export { getNotices, getInitNotice, getNotice, clearGetNoticeError };
export default reducer;
